
import TableList from "@components/templates/tablelist";
import { HttpBillTypeList } from "@/service/newbigaccount";
import { mapGetters } from "vuex";
import comIndex from './update';
import mixin from '../mixin';
export default {
    mixins: [TableList,mixin],
    components: {
        comIndex,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpBillTypeList,
        interceptRequest(params) {
            params.billingChannel = 'PAYABLE'
            params.warehouseId = params.search.warehouseId;
            delete params.search.warehouseId;
            return params
        },
        handleOperates(params = "", type, batch) {
            let url='';
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'payStoreBillTypeDetail',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    url=this.$router.resolve({
                        name: "payStoreBillTypeDetail",
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "query":
                    this.operate = {
                        title:'查看',
                        show:true,
                        width:1200,
                        component: "comIndex",
                        activeid:params,
                        querytype:'query',
                        showFooter:false
                    }
                    break;
                case "queryBlank":
                    url=this.$router.resolve({
                        name: "payStoreBillTypeDetail",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case "autoPO":
                    // 价格维护
                    url=this.$router.resolve({
                        name: "payPricemaintainDetail",
                        params: { type: "edit" },
                        query: { code: params.expenseCategoryCustomizeCode, orgid:params.organizationId,billtype:params.billtype },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'export':
                    this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/billing/billDelivery/export', this.formData, {
                        executor: 'request',
                        download: true,
                        method: 'post',
                    })
                    break;
            }
        },
        getOperateNodeMap(row){
            const { id, orderStatus, poPurchaseRelateEntityList } = row
            return [{
                label:'查看',
                show:true,
                params:id,
                operate:'query'
            },{
                label:'编辑',
                show:true,
                params:id,
                operate:'edit'
            },{
                label:'价格维护',
                show:true,
                params:{expenseCategoryCustomizeCode:row.code,organizationId:row.hostOrganizationId,billtype:row.expenseCategoryType},
                operate:'autoPO'
            },]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getCusBillTypeList']),
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add',{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                    // batch: true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: '费用类型',
                    tag: 'vSelect',
                    key: 'EQ_expenseCategoryType',
                    options: this.getCusBillTypeList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '费用类型代码',
                    tag: 'vInput',
                    key: 'CN_code',
                    show: true,
                },
                {
                    label: '状态',
                    tag: 'vSelect',
                    key: 'EQ_status',
                    options:[
                        {value:1,label:'禁用'},
                        {value:0,label:'启用'},
                    ],
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
                {
                    label: '自定义名称',
                    tag: 'vInput',
                    key: 'CN_name',
                },
                {
                    label: '仓库',
                    tag: 'vSelect',
                    key: 'warehouseId',
                    options: this.warehouseList,
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: '订单类型',
                    tag: 'vSelect',
                    key: 'CN_orderType',
                    options:this.getOrderList,
                    props:{
                        filterable:true,
                    },
                },
                {
                    label: '创建日期',
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                },

            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    width: 90,
                    render:this.getOperateNodes,
                },
                {
                    title: '费用类型',
                    key: 'expenseCategoryType',
                    render: (h, { row }) => this.findRenderLabel(this.getCusBillTypeList, row.expenseCategoryType),
                },
                {
                    title: '订单类型',
                    key: 'orderType',
                    render: (h, { row }) => {
                        // console.log('orderType', row.orderType)
                        if (!row.orderType || row.orderType == 0) return <div>--</div>
                        let textArr = row.orderType.split(',').map(value => {
                            return this.getOrderList.filter(item => {
                                return item.value == value
                            })[0].label;
                        });
                        return textArr.join(',');
                    }
                },
                {
                    title: '费用类型代码',
                    key: 'code',
                    render: (h,{row})=>{
                        if(row.code){
                            return  <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.code || '--'}</a>
                        }else{
                            return '--'
                        }
                    }
                },
                {
                    title: '自定义名称',
                    key: 'name',
                },
                {
                    title: '状态',
                    key: 'status',
                    render: (h, { row })=>{
                        return <div>{row.status === 0 ?'启用':'禁用'}</div>
                    },
                },
                {
                    title: '备注',
                    key: 'remark',
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                },
            ];
        },

    },

};
